export default __webpack_public_path__ + "921a8f6c1f678307936f4f0d276ec47f.svg";